import { render } from "./ArticlePage.vue?vue&type=template&id=20520519"
import script from "./ArticlePage.vue?vue&type=script&lang=js"
export * from "./ArticlePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__